import { createFileRoute, redirect } from '@tanstack/react-router'

/** The sidebar "Store Settings" entry lands on Config Jastip Fee. */
export const Route = createFileRoute('/_authed/settings/')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/jastip-fee', replace: true })
  },
})
